<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <b-row>
    <b-col class="columna-carrusel p-0" v-if="$localStorageService.can('Anuncio_postales')">
      <carrusel-dashboard/>
    </b-col>
    <b-col class="columna-grid p-0 ">
      <b-row>
        <b-col><estadistica-dashboard/></b-col>
      </b-row>
      <b-row> <b-col><AtajosDashboard></AtajosDashboard></b-col></b-row>
    </b-col>
  </b-row>
  <b-row>
    <b-col>
      <sesionesDashboard/>
    </b-col>
  </b-row>
</div>
</template>

<script>
import SesionesDashboard from "@/components/accionesDashboard/nuevoDashboard/sesionesDashboard";
import CarruselDashboard from "@/components/accionesDashboard/nuevoDashboard/carruselDashboard.vue";
import EstadisticaDashboard from "@/components/accionesDashboard/nuevoDashboard/estadisticaDashboard.vue";
import AtajosDashboard from "@/components/accionesDashboard/nuevoDashboard/atajosDashboard.vue";
export default {
  name: "DashboardNuevo",
  components: {
    EstadisticaDashboard,
    CarruselDashboard,
    SesionesDashboard,
    AtajosDashboard
  },
  data:() => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.obtenerVersionActualizada();

  },
  methods: {
    obtenerVersionActualizada(){

      let tiempo = localStorage.getItem("tiempoVersion");
      let minutos =  (new Date().getTime() - tiempo ) / 60000

      if (minutos > 30){
        console.log("Son más de 30min >>>>> se vuelve a ejecutar el sevicio para actualizar la versión <<<<<")
        var idUsuario = this.$localStorageService.getIdUsuario();
        this.$validarVersionNSD(idUsuario);
      }


    }
  }
}
</script>

<style scoped>
    .columna-grid{
  flex-basis: 25%;
  max-width: 50%;
  
}

@media (max-width: 1199px) {
  .columna-grid {
    flex-basis: 100%;
    max-width: 100%;
    margin-bottom: 5%;
  }

}

.columna-carrusel{
  flex-basis: 55%;
  max-width: 50%;
}

@media (max-width: 1199px) {
  .columna-carrusel {
    flex-basis: 100%;
    max-width: 100%;
  }

}
</style>
